import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { APIErrorResponse, AttentionTask, AttentionTaskType } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { QUERY_KEYS } from '@/constants'

export type AttentionTaskData = {
  type: AttentionTaskType
  message: string
  target_type: AttentionTask['target_type']
  target_id: number
}

export const usePostAttentionTask = (): UseMutationResult<
  AttentionTask,
  APIErrorResponse,
  AttentionTaskData
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()

  return useMutation(
    (data: AttentionTaskData) =>
      client
        .post(`plannings/attention_tasks/`, data)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async (result, data) => {
        await queryClient.invalidateQueries([
          QUERY_KEYS.ATTENTION_TASKS,
          data.target_type,
          data.target_id,
        ])
      },
    }
  )
}
